import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import { CirclesFour } from 'phosphor-react';

import DashboardComponent from '../../components/pages/dashboard';
import PageBase from '../../components/layout/PageBase';
import SignupAlertCard from '../../components/utility/SignupAlertCard';
import { toggleEmailVerifyModal } from '../../actions/dashboard';
import track from '../../lib/track';

interface Props {
  router: any;
  token: string | null;
  dispatch: any;
}

export const Dashboard: React.FC<Props> = ({ router, token, dispatch }) => {
  useEffect(() => {
    track.trackPage('Dashboard');
  }, []);

  useEffect(() => {
    if (router.query.verifyEmail && router.query.code) {
      dispatch(toggleEmailVerifyModal(true));
    }
  }, []);

  if (!token) {
    return (
      <PageBase title="Torii Homes - Manage your entire home search process from your Torii dashboard">
        <div className={`page-container col-xs-12 row center-xs`}>
          <SignupAlertCard
            subtext="Sign up to access your dashboard to manage your entire home search and purchase process."
            icon={<CirclesFour size={30} weight="fill" color="#636363" />}
          />
        </div>
      </PageBase>
    );
  }

  return (
    <PageBase title="Torii Homes - Manage your entire home search process from your Torii dashboard">
      <div className={`page-container col-xs-12 `}>
        <DashboardComponent router={router} />
      </div>
    </PageBase>
  );
};

const mapStateToProps = (state: any) => ({
  token: state.auth.token,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Dashboard));
